{
	"titleFirstPart": "Bienvenue sur",
	"titleSecondPart": "Heidelberg Materials {{productName}}",
	"totalCarbonStored": "Total de carbone stocké"
}
